import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import THEME from '../../theme';
import Panel from '../Panel';
import Badge from '../Badge';
import { Clock, HelpCircle, Info, Pause } from '../Icons';
import { useSelector } from 'react-redux';
import { selectUpdateTypesMap } from '@debbie/cortex/dist/update-types/selectors';
import UpdateTypeLabel from '../UpdateTypeLabel';
const UpdateWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  h3 {
    margin: 0;
  }

  p {
    margin: 0;
    font-size: 0.7em;
    opacity: 0.6;
    font-weight: bold;
  }

  @media ${THEME.MEDIA_QUERY_MOBILE} {
    display: block;

    p {
      margin-bottom: 20px;
    }
  }
`;
const ActiveUpdate = (props) => {
    const { quantity, updateTypeId, update, actions, label, description } = props;
    const lang = useSelector((s) => s.lang);
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    const updateType = updateTypeId ? updateTypesMap[updateTypeId] : undefined;
    const buildPauseMessage = (text, date, agoText) => {
        return `${text} ${moment.duration(date.diff(moment())).humanize()} ${agoText ? agoText + ' ' : ''}(${date.format(THEME.DATE_FORMAT_LONG)})`;
    };
    const getCasePauseText = (futureReminder, update, futurePause) => {
        if (futureReminder) {
            if (update.continuedAt && moment().isBefore(moment(update.continuedAt))) {
                // Paused and reminded in the future
                return buildPauseMessage(lang.updates.pausedUntil, futureReminder);
            }
            if (futurePause && futureReminder.format() === futurePause.format()) {
                // Paused and reminded in the future
                return buildPauseMessage(lang.updates.pausedAndReminded, futureReminder);
            }
            // Paused but reminded in the future
            return `${buildPauseMessage(lang.updates.pausedPast, moment(update.pausedAt), lang.updates.ago)}, ${buildPauseMessage(lang.updates.andReminded, moment(update.remindedAt))}`;
        }
        if (update.pausedAt === update.remindedAt) {
            // Paused and reminded
            return `${buildPauseMessage(lang.updates.pausedAndRemindedPast, moment(update.pausedAt), lang.updates.ago)} `;
        }
        // Paused x and reminded x
        return `${buildPauseMessage(lang.updates.pausedPast, moment(update.pausedAt), lang.updates.ago)}, ${buildPauseMessage(lang.updates.andRemindedPast, moment(update.remindedAt), lang.updates.ago)}`;
    };
    return (React.createElement(Panel, { secondary: true, style: {
            position: 'relative',
        }, bodyStyle: {
            minHeight: '67px',
            background: props.futureReminder
                ? `${THEME.COLOR_PRIMARY}b3`
                : undefined,
        }, stacked: !!(quantity && quantity > 1), attention: !!(update === null || update === void 0 ? void 0 : update.hiddenPermissionLevel) },
        !!quantity && quantity > 1 && (React.createElement(Badge, { style: { position: 'absolute', top: '-10px', left: '-4px' }, theme: THEME.WARNING }, quantity)),
        React.createElement(UpdateWrapper, null,
            React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    props.futureReminder ? (React.createElement(Clock, { style: {
                            margin: '0.2em 0.4em -0.2em 0',
                            float: 'left',
                        } })) : (updateType === null || updateType === void 0 ? void 0 : updateType.pausing) ? (React.createElement(Pause, { style: {
                            margin: '0.2em 0.4em -0.2em 0',
                            float: 'left',
                        } })) : (React.createElement(Info, { style: {
                            margin: '0.2em 0.4em -0.2em 0',
                            float: 'left',
                        } })),
                    React.createElement("div", { style: { paddingLeft: '30px', margin: '-5px 0' } },
                        React.createElement("h3", null,
                            React.createElement("b", null,
                                label ? (label) : updateType && updateTypeId ? (React.createElement(UpdateTypeLabel, { label: updateType.label, updateTypeId: updateTypeId })) : null,
                                (updateType === null || updateType === void 0 ? void 0 : updateType.knowledgeBaseUrls) &&
                                    updateType.knowledgeBaseUrls[lang.is.currently] && (React.createElement(React.Fragment, null,
                                    ' ',
                                    React.createElement("a", { href: updateType.knowledgeBaseUrls[lang.is.currently], style: {
                                            color: 'inherit',
                                            fontSize: '0.8em',
                                        }, target: "_blank", rel: "noreferrer" },
                                        React.createElement(HelpCircle, { style: {
                                                color: THEME.COLOR_ACCENT,
                                                height: '1.4em',
                                                width: '1.4em',
                                                margin: '0.2em 0 -0.2em 0.2em',
                                            } }))))),
                            React.createElement("small", null, (update === null || update === void 0 ? void 0 : update.update) && (React.createElement("span", { style: { fontWeight: 'normal' } },
                                ", ",
                                update.update)))),
                        React.createElement("p", null, description
                            ? description
                            : update
                                ? getCasePauseText(props.futureReminder || null, update, props.futurePause || null)
                                : ' '))),
                React.createElement("div", { style: {
                        gap: '0.3em',
                        display: 'flex',
                        alignItems: 'center',
                        margin: '-5px 0 -5px 0',
                    } }, actions)))));
};
export default ActiveUpdate;
//# sourceMappingURL=ActiveUpdate.js.map